module.exports = __webpack_public_path__ + "img/jed-smc.46b41351.jpg";